<ion-header [translucent]="false" class="ion-no-border custom-header" mode="md">
  <ion-toolbar>
    <ion-title class="modal-title">
      {{ 'unsaved_data' | translate }}
    </ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="homepage-content desktop-only">
  <div class="page-content">
    <div class="warning-box">
      <ion-icon name="warning-outline" class="warning-icon"></ion-icon>
      <span>
        {{ 'UNSAVED_WARNING_MSG' | translate }}
        
      </span>
    </div>
    <div class="select-group">
      <p class="confirm-question"> {{ 'WARNING_CONFIRM' | translate }}</p>
    </div>
    
  </div>
  
</ion-content>

<ion-footer [translucent]="false" class="ion-no-border ">
    <!-- Button Container -->
    <div class="button-container">
      <ion-button fill="outline" class="cancel-btn" (click)="cancel()" expand="block">
        {{'cancel' | translate}}
      </ion-button>
      <ion-button class="next-btn" (click)="next()" expand="block">
        {{'Confirm' |translate}}
      </ion-button>
    </div>
</ion-footer>
